import { render } from "./upload-link.vue?vue&type=template&id=1264c91e"
import script from "./upload-link.vue?vue&type=script&lang=js"
export * from "./upload-link.vue?vue&type=script&lang=js"
script.render = render

export default script